import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import useDynamicColors from "../../../../../hooks/useDynamicColors";
import SvgFondo from "./SvgFondo";

export const OnboardingSuccessVisaMobile = () => {
  const colors = useDynamicColors();
  const location = useLocation();
  const navigate = useNavigate();

  const handleButtonClickLanding = () => {
    const currentParams = location.search;
    navigate(`/vxlab-landing-visa-mobile${currentParams}`);
  };

  const handleButtonClickOnboarding = () => {
    const currentParams = location.search;
    navigate(`/vxlab-landing-visa-mobile${currentParams}`);
  };

  const styles = {
    telefono: {
      fontFamily: "Open Sans, sans-serif",
      marginTop: "30px",
      backgroundColor: "#ffffff",
      display: "flex",
      borderRadius: "50px",
      border: "15px solid #000000",
      flexDirection: "row",
      justifyContent: "center",
      width: "100%",
    },
    page: {
      minHeight: "100vh",
      fontFamily: "Open Sans, sans-serif",
      display: "flex",
      alignItems: "flex-start",
      flexDirection: "column",
      justifyContent: "center",
      borderRadius: "30px",
      position: "relative",
      overflow: "hidden",
    },
    svgFondo: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "300px",
      zIndex: 0,
    },
    card: {
      width: "375px",
      height: "812px",
      justifyContent: "flex-start",
      background: colors.primario,
      borderRadius: "4px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: "24px",
      paddingBottom: "64px",
      position: "relative",
      color: "white",
      boxSizing: "border-box",
      zIndex: 1,
    },
    content: {
      display: "flex",
      position: "relative",
      flexDirection: "column",
      zIndex: 2,
    },
    welcomeText: {
      fontFamily: "Open Sans, sans-serif",
      fontSize: "20px",
      marginBottom: "16px",
      fontWeight: "normal",
    },
    name: {
      fontWeight: "bold",
    },
    menuIcon: {
      marginLeft: "12px",
      fontWeight: "bold",
    },
    faceIdButton: {
      width: "100%",
      backgroundColor: colors.secundario,
      padding: "20px 16px",
      borderRadius: "2px",
      fontWeight: "500",
      textAlign: "center",
      color: colors.primario,
      fontSize: "15px",
      marginBottom: "16px",
      border: "none",
      cursor: "pointer",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    passwordButton: {
      width: "100%",
      backgroundColor: "transparent",
      color: "white",
      padding: "20px 16px",
      border: "1px solid white",
      borderRadius: "2px",
      fontSize: "15px",
      fontWeight: "400",
      marginBottom: "16px",
      cursor: "pointer",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    arrow: {
      fontSize: "26px",
      marginLeft: "8px",
    },
    supportText: {
      fontSize: "12px",
      color: "white",
    },
    clickHere: {
      color: colors.secundario,
      cursor: "pointer",
      textDecoration: "underline",
    },
  };

  return (
    <div style={styles.telefono}>
      <div style={styles.page}>
        <div style={styles.card}>
          <svg
            width={65}
            height={64}
            viewBox="0 0 65 64"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M53.3578 11.3663C47.7865 5.85495 40.379 2.81963 32.5 2.81963C24.6208 2.81963 17.2132 5.85495 11.642 11.3663C6.07065 16.8777 3.00244 24.2056 3.00244 32C3.00244 39.7943 6.07065 47.1221 11.642 52.6336C17.2133 58.145 24.6208 61.1803 32.5 61.1803C40.379 61.1803 47.7865 58.145 53.3578 52.6336C58.9292 47.1221 61.9975 39.7943 61.9975 32C61.9975 24.2056 58.9292 16.8778 53.3578 11.3663ZM32.5 57.7608C18.141 57.7608 6.45918 46.2046 6.45918 32C6.45918 17.7954 18.141 6.2392 32.5 6.2392C46.8589 6.2392 58.5408 17.7954 58.5408 32C58.5408 46.2046 46.8589 57.7608 32.5 57.7608Z"
              fill={colors.secundario}
              stroke="#F9C017"
              strokeWidth={1.3913}
            />
            <path
              d="M45.7829 19.0405L25.9667 38.6436L19.2172 31.9666L16.0437 35.106L24.3799 43.3526L25.9667 44.9595L27.5533 43.3526L48.9563 22.1797L45.7829 19.0405Z"
              fill="white"
            />
          </svg>

          <p
            style={{
              fontSize: 22,
              fontWeight: 600,
              textAlign: "center",
              marginTop: 12,
              lineHeight: 1.1,
              marginBottom: 8,
            }}
          >
            Congratulations! Your application has been approved!
          </p>
          <div
            style={{
              background: colors.primario,
              textAlign: "center",
              fontSize: 16,
              lineHeight: 1.1,
              marginTop: 10,
              fontWeight: 200,
            }}
          >
            Start using your wallet and enjoy all the benefits we’ve prepared
            for you. Your experience begins now!
          </div>

          <div
            style={{
              position: "absolute",
              background: colors.primario,
              padding: 20,
              zIndex: 9,
              bottom: 30,
              height: 85,
              width: "100%",
            }}
          >
            <button
              onClick={handleButtonClickOnboarding}
              style={styles.faceIdButton}
            >
              <div
                style={{
                  textAlign: "center",
                  width: "100%",
                  alignItems: "center",
                  fontWeight: 600,
                }}
              >
                Lett’s Start
              </div>
            </button>
          </div>
          <div style={{ position: "absolute", bottom: -20, left: 0 }}>
            <svg
              width={375}
              height={547}
              viewBox="0 0 375 547"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_629_375)">
                <g clipPath="url(#clip1_629_375)">
                  <path
                    d="M63.2116 224.054C80.7628 221.697 86.8886 199.728 76.2448 186.742C74.717 184.88 66.6668 178.242 67.1227 176.507L105.227 138.16L106.438 137.582C115.43 145.224 119.436 152.747 133.02 151.16C141.082 150.216 150.494 140.703 155.592 134.651C162.642 126.281 168.783 109.976 164.874 99.303C163.35 95.1343 152.241 83.6467 148.507 80.1412C145.251 77.0827 133.138 70.273 132.324 66.7231C130.696 59.6262 136.069 57.6307 141.976 57.0859C150.701 56.2806 157.381 58.1725 164.167 63.5906L167.764 16.5535C170.384 5.96882 184.622 6.33595 187.118 16.666C189.037 24.6126 188.954 35.2683 190.313 43.6708C190.52 44.9558 190.893 48.5175 191.562 49.234C199.921 53.61 212.415 53.8854 218.635 61.5359C228.515 73.6808 218.854 87.241 215.085 99.9988C212.021 110.373 210.159 119.238 210.926 130.237C212.258 149.381 232.874 158.589 248.207 147.332L308.36 86.6873H347.738V95.8656C347.738 96.8427 346.074 100.2 345.367 101.192C340.017 108.694 331.2 105.376 323.422 106.486C321.835 112.339 320.662 118.326 318.418 123.984C317.938 125.192 314.362 133.118 313.921 133.396C312.668 134.189 307.588 130.681 307.549 130.225C307.517 129.831 310.631 124.419 311.129 123.208C312.002 121.085 312.861 118.939 313.551 116.748C314.477 113.808 316.719 100.404 317.219 99.6909C318.232 98.249 334.018 99.7175 337.248 98.9951C339.632 98.4622 340.766 95.3978 340.632 93.201H311.913L255.082 150.654C236.175 168.297 205.78 156.901 203.823 130.823C202.846 117.808 206.011 105.313 209.937 93.0736C211.778 87.3298 217.075 77.3758 216.006 71.8541C212.909 55.8394 186.733 63.3242 183.785 47.8277C181.922 38.0306 182.061 27.2151 179.876 17.3736C176.744 13.3174 174.642 16.8791 174.245 20.6718C172.913 33.3941 173.108 46.4125 171.862 59.1466C171.299 64.8904 171.4 72.4551 163.323 71.256C160.392 70.8208 159.116 68.4196 156.883 67.031C152.108 64.0555 145.144 62.285 139.904 65.074C143.462 68.1502 147.927 70.6135 151.453 73.6453C156.019 77.5742 168.865 90.557 170.973 95.5755C182.867 123.889 142.595 174.725 113.645 153.496C112.025 152.309 107.602 147.066 106.438 147.063C96.0521 156.208 86.4741 166.66 76.5764 176.478C81.7103 182.337 86.5511 187.527 88.2268 195.494C90.927 208.329 83.9456 223.165 71.7888 228.498C70.0746 229.25 64.1975 231.171 62.6195 231.171H52.849V274.398H63.2116C68.9762 274.398 78.5867 280.604 82.1662 285.051C92.3541 297.702 90.3556 313.761 79.8006 325.331C74.9746 330.622 74.1574 332.828 68.8488 326.211C78.6459 317.648 85.4645 307.943 79.7858 294.54C77.7399 289.711 69.1035 281.504 63.8067 281.504H46.3384V224.065C51.6203 223.556 58.0925 224.752 63.2146 224.065L63.2116 224.054Z"
                    fill={colors.secundario}
                  />
                  <path
                    d="M344.185 138.192C343.842 139.243 343.123 140.049 342.427 140.875C339.306 144.576 330.086 154.142 326.433 156.857C325.728 157.378 325.157 158.05 324.224 158.201L294.824 158.242C293.021 157.653 294.149 152.827 293.853 151.219H321.98C323.934 149.967 334.086 138.192 335.007 138.192H344.185Z"
                    fill={colors.secundario}
                  />
                  <path
                    d="M354.252 473.94H306.88V480.453H354.252V473.94Z"
                    fill={colors.secundario}
                  />
                  <path
                    d="M155.667 -3.28641C156.519 -3.43445 161.384 0.98889 159.735 2.58177L138.74 23.0878C137.938 23.2921 127.14 12.4529 126.93 11.6535C126.592 10.3685 130.249 6.71791 131.309 6.71791C133.026 6.71791 137.505 13.4565 138.927 13.2108C141.656 11.5143 154.16 -3.01995 155.669 -3.28345L155.667 -3.28641Z"
                    fill={colors.secundario}
                  />
                  <path
                    d="M141.547 293.851L138.174 300.273L200.585 333.053L203.957 326.631L141.547 293.851Z"
                    fill={colors.secundario}
                  />
                  <path
                    d="M15.4134 353.9C28.1919 352.378 40.772 360.384 44.0585 372.887C46.507 382.198 45.977 414.974 45.1747 425.703C42.6195 459.784 -4.6397 459.438 -7.54122 426.855C-8.65149 414.384 -8.55675 391.433 -7.57083 378.879C-6.57898 366.24 2.57561 355.427 15.4134 353.9ZM14.7975 360.982C7.4934 362.125 0.683701 369.446 -0.290381 376.685C0.6008 392.91 -2.01353 411.498 -0.438417 427.45C1.70812 449.179 34.3117 450.402 37.7787 428.374C40.1444 413.348 36.5678 393.816 38.0393 378.314C36.3458 366.37 26.8448 359.099 14.7975 360.982Z"
                    fill={colors.secundario}
                  />
                  <path
                    d="M100.025 405.479C105.831 405.461 111.525 409.949 112.513 415.755C114.642 428.238 102.03 435.429 92.9253 440.688C85.8165 435.717 75.8892 431.127 73.9588 421.745C71.9218 411.859 78.8055 404.851 88.6796 405.84C90.3583 406.009 91.889 407.071 93.3635 407C95.1192 406.917 97.6713 405.484 100.025 405.479ZM84.6619 412.469C79.1727 413.662 80.1349 421.082 82.7877 424.753C83.9217 426.319 90.835 431.779 92.5078 432.25C93.9734 432.661 99.735 428.359 101.088 427.139C104.549 424.022 107.883 419.119 104.697 414.686C100.484 408.821 94.5241 415.474 92.9223 415.225C90.9475 414.917 88.8424 411.56 84.6589 412.469H84.6619Z"
                    fill={colors.secundario}
                  />
                  <path
                    d="M305.503 439.711C305.503 447.915 298.854 454.565 290.649 454.565C282.445 454.565 275.795 447.915 275.795 439.711C275.795 431.506 282.445 424.857 290.649 424.857C298.854 424.857 305.503 431.506 305.503 439.711ZM298.635 439.717C298.635 435.29 295.046 431.702 290.62 431.702C286.193 431.702 282.605 435.29 282.605 439.717C282.605 444.143 286.193 447.731 290.62 447.731C295.046 447.731 298.635 444.143 298.635 439.717Z"
                    fill={colors.secundario}
                  />
                  <path
                    d="M391.376 439.817C391.376 448.004 384.738 454.642 376.552 454.642C368.365 454.642 361.728 448.004 361.728 439.817C361.728 431.631 368.365 424.993 376.552 424.993C384.738 424.993 391.376 431.631 391.376 439.817ZM384.602 439.829C384.602 435.376 380.993 431.767 376.54 431.767C372.087 431.767 368.478 435.376 368.478 439.829C368.478 444.282 372.087 447.891 376.54 447.891C380.993 447.891 384.602 444.282 384.602 439.829Z"
                    fill={colors.secundario}
                  />
                  <path
                    d="M322.658 204.898C321.737 205.83 313.092 211.974 312.399 212.095C304.772 208.43 295.472 202.402 297.539 192.51C298.33 188.732 302.8 185.138 306.637 185.031C308.506 184.981 310.611 186.171 312.452 186.103C313.977 186.047 315.505 184.984 317.184 185.028C327.673 185.309 329.562 197.91 322.658 204.898ZM306.128 192.181C299.514 194.073 309.077 204.859 312.811 203.687C316.434 202.55 323.753 193.813 318.306 192.19C314.936 191.186 313.145 194.328 311.922 194.257C310.83 194.195 309.003 191.361 306.131 192.181H306.128Z"
                    fill={colors.secundario}
                  />
                  <path
                    d="M-6.58151 244.823C-5.40017 244.616 -1.4476 249.954 -0.0678943 250.659L6.44572 244.823C7.04379 244.72 10.8394 248.355 11.1355 248.93C11.9616 250.531 6.2444 254.262 5.51902 255.816L11.3546 262.33C11.4582 262.928 7.82247 266.724 7.24809 267.02C5.64633 267.846 1.9158 262.129 0.361416 261.403L-6.1522 267.239C-6.75027 267.343 -10.5459 263.707 -10.842 263.132C-11.668 261.531 -5.95087 257.8 -5.22549 256.246L-11.0611 249.732C-11.1766 249.063 -7.05226 244.906 -6.58151 244.823Z"
                    fill={colors.secundario}
                  />
                  <path
                    d="M17.6163 259.582H37.7493C39.0639 259.582 39.0639 266.688 37.7493 266.688H17.6163C16.3017 266.688 16.3017 259.582 17.6163 259.582Z"
                    fill={colors.secundario}
                  />
                  <path
                    d="M362.542 195.038V201.552H343.889C343.827 201.552 343.001 202.378 343.001 202.44V287.413H365.503V293.927H335.896V195.927C335.896 195.864 336.722 195.038 336.784 195.038H362.542Z"
                    fill={colors.secundario}
                  />
                  <path
                    d="M384.922 271.011C391.877 270.217 418.296 269.904 424.265 271.582C429.345 273.009 433.156 277.749 433.621 282.952C436.016 309.684 431.779 339.957 433.6 367.063C432.389 374.095 427.24 378.035 420.297 378.631C411.365 379.397 393.041 379.486 384.23 378.536C378.361 377.902 374.213 374.722 372.307 369.141L372.067 281.847C373.512 275.183 378.388 271.763 384.922 271.017V271.011ZM427.086 355.51V282.972C427.086 281.504 423.447 277.601 421.408 277.992C409.615 278.718 396.333 276.844 384.721 277.909C382.252 278.137 378.53 280.399 378.53 282.969V355.507H427.086V355.51ZM427.086 362.024H378.53C377.888 366.856 379.424 371.039 384.721 371.525C396.656 372.623 410.397 370.752 422.521 371.374C426.63 369.84 427.51 366.074 427.086 362.024Z"
                    fill={colors.secundario}
                  />
                  <path
                    d="M-6.52828 146.619C4.75804 147.581 19.7601 144.848 30.6053 146.521C35.7066 147.308 38.2617 152.777 38.6585 157.416C39.3157 165.138 39.3957 180.581 38.6288 188.223C38.0574 193.928 34.7977 198.094 28.888 198.615C20.7223 199.334 3.15332 199.453 -4.891 198.591C-10.8746 197.952 -13.6133 193.247 -14.09 187.657C-14.765 179.74 -14.7769 164.75 -14.0574 156.854C-13.5807 151.616 -11.6089 148.442 -6.53124 146.616L-6.52828 146.619ZM-4.76072 153.123C-6.00127 153.718 -6.99312 154.781 -6.99015 156.223C-5.93021 166.37 -8.29584 179.027 -6.99015 188.85C-6.68816 191.124 -5.33806 191.835 -3.1264 192.092C3.75731 192.889 20.0739 192.747 27.1145 192.107C28.6541 191.968 29.8503 191.853 30.9783 190.642V154.435L27.6919 152.984L-4.76368 153.123H-4.76072Z"
                    fill={colors.secundario}
                  />
                  <path
                    d="M380.954 81.435C380.744 81.7222 382.15 85.6067 382.106 86.9568C382.035 89.1033 379.672 92.5082 379.832 93.3845C380.167 95.2291 382.402 96.8308 382.056 100.52C381.588 105.532 376.279 108.348 376.232 108.869C376.199 109.236 378.263 112.238 378.491 113.654C381.079 129.902 355.332 129.505 359.243 112.691C359.661 110.9 361.943 108.718 361.943 107.7C361.943 106.681 359.394 104.162 359.042 101.728C358.367 97.0588 360.795 94.6932 360.735 92.8931C360.706 92.0078 359.288 90.3942 359.042 88.7007C358.121 82.3025 361.727 77.3255 368.164 76.609C371.356 76.2537 377.742 78.2049 377.994 73.9444C378.21 70.273 375.142 71.0547 374.941 70.3234C374.509 68.7542 375.32 65.4352 374.98 63.5818C383.995 63.8512 388.202 73.3433 382.689 80.4935C382.227 81.0916 381.108 81.2218 380.954 81.4321V81.435ZM366.239 88.9049C367.779 90.4386 376.596 90.9686 374.867 85.3136C373.345 80.3395 361.68 84.3602 366.239 88.9049ZM366.239 101.932C367.779 103.466 376.602 103.993 374.867 98.3408C373.316 93.2839 361.638 97.346 366.239 101.932ZM371.942 115.821C371.942 114.033 370.494 112.585 368.706 112.585C366.917 112.585 365.47 114.033 365.47 115.821C365.47 117.609 366.917 119.057 368.706 119.057C370.494 119.057 371.942 117.609 371.942 115.821Z"
                    fill={colors.secundario}
                  />
                  <path
                    d="M48.1121 36.343H28.5713V42.8566H48.1121V36.343Z"
                    fill={colors.secundario}
                  />
                  <path
                    d="M35.0849 20.355H28.5713V29.8294H35.0849V20.355Z"
                    fill={colors.secundario}
                  />
                  <path
                    d="M48.1122 20.355H41.5986V29.8294H48.1122V20.355Z"
                    fill={colors.secundario}
                  />
                  <path
                    d="M213.321 473.94H148.185V480.453H213.321V473.94Z"
                    fill={colors.secundario}
                  />
                  <path
                    d="M205.031 405.843V414.429L197.925 431.897H165.061C164.999 431.897 164.173 431.071 164.173 431.009V412.652C164.173 412.111 159.8 403.267 159.341 402.98C158.103 402.204 152.398 403.755 151.403 402.328C150.935 401.656 150.935 397.005 151.403 396.333C151.954 395.542 162.562 395.445 163.587 396.066C165.055 396.961 166.974 404.564 169.206 405.843H205.031ZM197.925 412.356H171.279V425.384H193.188L197.925 412.356Z"
                    fill={colors.secundario}
                  />
                  <path
                    d="M109.767 97.9411C109.767 119.569 92.2332 137.103 70.605 137.103C48.9768 137.103 31.4434 119.569 31.4434 97.9411C31.4434 76.3129 48.9768 58.7795 70.605 58.7795C92.2332 58.7795 109.767 76.3129 109.767 97.9411ZM102.921 97.953C102.921 80.1145 88.4582 65.6513 70.6198 65.6513C52.7814 65.6513 38.3182 80.1145 38.3182 97.953C38.3182 115.791 52.7814 130.255 70.6198 130.255C88.4582 130.255 102.921 115.791 102.921 97.953Z"
                    fill={colors.secundario}
                  />
                  <path
                    d="M9.03354 97.9263C7.83149 97.6954 3.07654 98.2905 2.5821 97.8582C2.38669 97.6865 1.9337 94.48 0.462215 93.1714C-2.03072 90.9508 -6.19055 91.0396 -8.53545 93.3905C-9.59836 94.4534 -10.383 97.7161 -10.5902 97.8493C-10.9129 98.0595 -15.3659 98.0447 -16.1564 97.9322C-17.0446 97.8049 -17.0979 98.2786 -17.0328 97.044C-16.1682 80.7866 9.06019 81.0294 9.03058 97.9263H9.03354Z"
                    fill={colors.secundario}
                  />
                  <path
                    d="M6.06975 71.8718V81.9383C3.22744 81.4824 -0.627435 83.4424 -1.06562 79.8954C-1.94792 72.7097 -1.53638 70.9481 6.06975 71.8718Z"
                    fill={colors.secundario}
                  />
                </g>
              </g>
              <defs>
                <clipPath id="clip0_629_375">
                  <rect width={375} height={547} rx={40} fill={colors.quinto} />
                </clipPath>
                <clipPath id="clip1_629_375">
                  <rect
                    width={539.446}
                    height={514.709}
                    fill={colors.quinto}
                    transform="translate(-76.8311 -21.1989)"
                  />
                </clipPath>
              </defs>
            </svg>
          </div>
          <div style={{ position: "absolute", bottom: -20, left: 0 }}>
            <svg
              width={375}
              height={547}
              viewBox="0 0 375 547"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_629_286)">
                <g clipPath="url(#clip1_629_286)">
                  <path
                    d="M318.723 224.646V280.9H302.439C292.929 280.9 283.472 294.211 283.185 303.132C282.809 314.827 291.437 320.772 298.018 328.568C285.856 342.057 272.219 354.557 259.496 367.67C258.86 368.132 258.395 367.972 257.744 367.67C255.982 366.856 250.546 360.008 248.263 358.169C233.232 346.062 210.44 357.079 210.952 376.235H226.644C229.661 376.235 235.822 380.437 235.822 383.637V447.885H229.309V385.414C229.309 385.251 227.882 383.978 227.52 383.649L133.967 383.634C133.556 383.836 132.194 385.748 132.194 386.006V447.885H125.68V383.637C125.68 383.282 128.155 379.483 128.7 378.959C129.825 377.876 133.422 376.235 134.858 376.235H154.103C153.777 357.189 137.387 354.72 121.807 355.487C89.5561 357.071 62.5424 379.581 58.2493 412.134C57.3019 419.311 58.2671 426.642 56.7009 433.68C53.074 449.969 38.7499 462.351 22.309 464.424C21.7109 465.256 21.7701 482.763 22.0218 484.924C22.0928 485.519 22.2912 486.967 22.9396 486.967H32.1179C32.035 488.151 32.5887 493.48 31.2297 493.48H5.47129V486.967H14.6496C15.298 486.967 15.4993 485.522 15.5674 484.924C15.822 482.763 15.8812 465.256 15.2832 464.424C4.31364 462.819 -5.29987 458.052 -12.1895 449.262C-21.1664 437.813 -20.7875 424.513 -20.5832 410.574H-13.4745V429.23C-13.4745 438.671 -3.61521 450.425 4.67189 454.31C25.9684 464.297 48.9023 449.57 50.9955 426.784C52.2983 412.605 50.9689 405.304 57.0769 391.415C71.1048 359.513 102.838 345.897 136.626 349.003C150.417 350.27 161.52 362.403 161.206 376.235L203.814 376.2C204.841 350.361 232.962 337.106 253.525 353.494C254.895 354.586 258.197 358.88 259.502 358.207L289.104 328.565C278.294 319.49 273.501 306.93 278.608 293.19C283.89 278.978 296.982 272.98 311.617 273.794V231.156H301.252C299.973 231.156 294.726 229.17 293.267 228.483C276.698 220.705 271.253 198.041 282.614 183.503C283.369 182.535 290.356 175.432 290.901 175.181C292.633 174.381 296.828 178.257 295.662 179.956C294.175 182.121 290.614 184.498 288.811 186.742C280.491 197.081 281.853 211.678 292.384 219.897C294.637 221.655 300.914 224.649 303.62 224.649H318.72L318.723 224.646Z"
                    fill={colors.quinto}
                  />
                  <path
                    d="M341.225 460.912H272.536V467.426H341.225V460.912Z"
                    fill={colors.quinto}
                  />
                  <path
                    d="M160.027 34.5666C159.734 36.1743 160.859 41.0003 159.056 41.5895C157.253 42.1786 142.491 41.8826 139.575 41.696C96.499 38.9662 98.8172 -18.0338 137.203 -20.5327C149.996 -21.3646 170.13 -21.4831 182.849 -20.5268C213.732 -18.2085 222.591 22.8125 195.562 37.5273C195.968 35.1439 194.384 32.5533 195.083 30.2498C195.438 29.0804 198.668 26.6762 199.687 25.3765C209.916 12.3285 204.326 -7.52321 188.421 -12.4795C179.53 -15.2507 150.494 -14.6704 140.164 -14.0131C125.65 -13.0894 113.668 -3.73939 114.408 11.7897C114.856 21.1545 124.966 34.5666 134.858 34.5666H160.025H160.027Z"
                    fill={colors.quinto}
                  />
                  <path
                    d="M222.203 224.054C222.342 223.959 223.34 221.04 223.31 220.874C223.151 220.018 218.849 217.848 217.922 215.012C217.324 213.185 217.635 208.382 217.41 208.122C216.933 207.568 211.355 207.702 208.681 203.527C208.024 202.502 207.343 199.796 206.834 199.453C205.611 198.627 201.244 199.586 199.08 198.917C197.061 198.292 194.654 194.218 193.407 193.973C192.303 193.753 190.124 195.37 188.711 195.589C182.754 196.513 181.458 192.371 179.175 192.175C178.313 192.101 173.881 195.912 170.831 196.078C168.466 196.208 165.635 194.263 163.892 194.437C161.68 194.657 160.359 200.178 154.938 200.907C153.458 201.105 149.585 200.619 148.872 201.061C148.49 201.297 146.965 206.585 145.544 208.095C143.658 210.1 138.559 210.976 137.813 212.208C137.008 213.534 137.905 217.679 136.638 220.507C135.696 222.612 131.64 225.324 131.611 226.704C131.587 227.799 133.378 230.138 133.707 231.719C136.724 246.256 138.394 247.05 144.934 259.574C150.243 269.741 154.311 279.997 150.243 291.573C149.091 291.067 144.357 289.208 144.137 288.257C143.918 287.307 145.266 283.434 145.266 281.794C145.274 267.106 130.414 253.853 127.605 239.6C127.249 237.797 127.59 236.006 127.193 234.091C126.154 229.037 122.305 227.216 126.367 221.496C128.431 218.591 130.554 219.133 131.007 214.881C131.371 211.438 130.03 209.691 133.055 206.864C135.371 204.702 138.4 205.004 140.206 203.355C142.281 201.46 142.029 196.978 145.588 195.118C148.49 193.602 151.788 194.455 154.278 193.742C156.484 193.108 158.503 187.945 162.843 187.456C165.523 187.154 168.27 189.253 170.349 189.111C173.446 188.901 174.381 184.868 180.463 185.555C183.385 185.884 185.804 188.901 186.959 188.91C187.876 188.916 190.917 187.083 192.451 186.87C198.423 186.044 199.767 192.033 201.901 192.59C204.329 193.224 206.419 190.707 210.55 193.366C213.821 195.471 213.38 199.006 214.63 200.237C216.015 201.602 220.684 200.75 223.056 204.542C224.823 207.373 223.242 209.884 224.282 212.199C224.948 213.682 227.882 214.813 228.983 216.379C232.444 221.303 228.619 223.725 228.104 227.888C227.686 231.254 227.583 246.762 228.243 249.688C229.099 253.474 235.583 260.847 237.033 265.178C238.298 268.956 237.516 273.03 234.656 275.887C232.53 278.01 228.042 278.374 227.254 279.736C225.294 283.123 224.288 293.643 222.632 298.208C219.083 307.988 210.618 305.326 202.165 305.871C201.629 306.205 198.769 314.175 197.632 315.256C196.223 316.594 191.435 313.953 191.409 312.609C191.397 311.967 196.383 301.885 197.058 301.056C201.099 296.106 211.562 300.47 214.846 298.119C217.448 296.257 220 275.067 221.738 273.332C223.672 271.399 232.21 273.815 230.031 266.857C229.084 263.837 221.022 252.447 221.022 251.002V231.165H192.007L196.791 250.925C196.655 251.609 190.843 252.933 190.275 252.438C189.17 251.479 184.146 227.5 183.124 224.063H222.206L222.203 224.054Z"
                    fill={colors.quinto}
                  />
                  <path
                    d="M177.792 245.371V251.887C164.617 248.974 158.681 265.708 173.028 267.896C173.369 274.383 173.78 276.388 166.959 273.673C156.934 269.684 154.956 255.511 163.033 248.675C163.909 247.932 168.383 245.374 169.206 245.374H177.792V245.371Z"
                    fill={colors.quinto}
                  />
                  <path
                    d="M321.684 132.271C321.382 131.984 323.581 126.065 323.99 125.532C324.94 124.295 351.338 125.704 355.125 125.18C357.464 126.37 358.773 128.478 361.162 129.81C362.885 130.773 364.223 129.813 363.726 132.271H321.684Z"
                    fill={colors.quinto}
                  />
                  <path
                    d="M281.421 71.8689C281.148 73.3996 281.93 77.3699 281.163 78.4269C280.843 78.868 276.624 79.3181 274.587 81.3255C271.754 84.1145 272.219 88.1736 271.949 88.4579C271.706 88.7154 265.119 88.677 264.864 88.4283C264.651 88.218 264.382 84.7273 263.067 82.8236C260.411 78.9805 257.72 80.0287 255.94 78.6993C254.73 77.7933 255.624 73.5239 255.36 71.8718C260.399 71.629 264.802 74.1664 268.174 77.7548C272.124 74.4684 275.825 71.4366 281.418 71.8718L281.421 71.8689Z"
                    fill={colors.quinto}
                  />
                  <path
                    d="M248.269 37.5214C249.412 38.383 249.575 36.3786 250.3 35.745C253.317 33.1159 257.835 31.2032 261.877 31.6029C261.679 32.7132 262.161 37.7761 261.847 38.0958C261.569 38.38 257.27 38.6287 254.742 41.3497C252.403 43.8633 252.633 47.3422 252.397 47.5938C252.16 47.8455 245.569 47.8159 245.317 47.5702C245.066 47.3244 245.001 43.5998 242.952 41.3526C240.447 38.611 236.124 38.383 235.846 38.0988C235.532 37.779 236.018 32.7162 235.817 31.6059C240.255 31.1588 244.391 33.2491 247.63 36.1092C248.166 36.5829 248.204 37.477 248.266 37.5244L248.269 37.5214Z"
                    fill={colors.quinto}
                  />
                  <path
                    d="M399.255 426.864C391.536 419.557 380.798 417.102 370.53 415.915L268.734 415.874C268.091 415.983 266.129 427.273 266.031 428.646C265.88 430.722 266.715 440.321 266.359 440.815C265.824 441.561 261.326 442.044 260.109 442.556C257.981 432.534 259.18 420.868 262.955 411.359C267.12 400.86 272.704 390.32 285.246 389.239C304.162 387.611 325.349 390.527 344.514 389.23L346.29 389.822L364.922 408.496C375.587 409.36 386.065 410.574 395.631 415.684C398.405 417.168 405.171 421.413 405.742 424.522C405.147 426.873 407.16 440.492 406.331 441.339C405.991 441.685 400.294 442.091 399.258 441.961V426.861L399.255 426.864ZM271.943 408.803H283.49C285.033 405.547 288.74 400.454 289.693 397.239C290.022 396.129 289.509 396.457 288.828 396.368C279.182 395.092 275.277 400.91 271.94 408.803H271.943ZM291.484 408.803H326.421L322.193 396.451C319.066 396.667 298.093 395.738 297.344 396.736L291.484 408.803ZM354.844 408.803C353.269 407.382 343.572 396.368 342.705 396.368H329.382L333.527 408.803H354.844Z"
                    fill={colors.quinto}
                  />
                  <path
                    d="M355.436 437.819H311.588V444.924H355.436V437.819Z"
                    fill={colors.quinto}
                  />
                  <path
                    d="M346.471 356.772C347.205 358.246 343.066 362.048 342.11 362.048C341.681 362.048 336.692 358.116 335.481 357.402C325.231 351.38 313.216 350.785 302.543 356.209C300.873 357.056 294.658 362.045 294.146 362.045C293.252 362.045 289.687 358.551 289.681 357.58C289.663 355.185 301.388 349.014 303.922 348.114C318.821 342.823 334.696 346.593 346.468 356.769L346.471 356.772Z"
                    fill={colors.quinto}
                  />
                  <path
                    d="M316.236 358.652C323.83 358.172 332.745 361.062 337.651 367.019L332.724 371.451C326.157 365.405 317.358 363.685 309.127 367.528C307.801 368.147 303.466 371.519 303.114 371.457C302.593 371.365 298.489 367.14 298.617 366.527C303.227 361.944 309.699 359.063 316.236 358.649V358.652Z"
                    fill={colors.quinto}
                  />
                  <path
                    d="M328.126 375.119C328.89 376.422 324.899 380.342 323.774 380.369C321.719 380.416 320.381 377.701 315.715 378.859C314.465 379.169 313.124 380.594 312.035 380.321C311.374 380.155 308.026 376.733 308.029 375.933C308.035 373.615 315.798 371.495 317.838 371.457C319.593 371.424 322.143 372.025 323.78 372.665C324.316 372.875 327.999 374.909 328.126 375.125V375.119Z"
                    fill={colors.quinto}
                  />
                  <path
                    d="M-70.3174 231.159V274.386H37.7494C39.0639 274.386 39.0639 281.492 37.7494 281.492H-76.8311V224.054H37.7494C39.0639 224.054 39.0639 231.159 37.7494 231.159H-70.3174Z"
                    fill={colors.quinto}
                  />
                  <path
                    d="M14.8302 311.866C25.0299 310.818 36.5442 313.794 44.5116 320.328C49.1747 324.153 47.6914 325.035 43.1674 328.224C30.9248 316.917 13.6755 315.25 -0.281389 324.585C-1.7736 325.583 -3.89644 328.594 -5.35608 328.212C-6.27983 327.97 -9.5544 324.517 -9.26129 323.363C-9.01259 322.38 -3.64478 318.501 -2.39831 317.734C2.5846 314.679 8.99459 312.47 14.8302 311.869V311.866Z"
                    fill={colors.quinto}
                  />
                  <path
                    d="M14.8094 324.873C22.9722 323.765 33.6515 326.202 38.596 333.225C33.5657 340.165 33.0446 335.552 27.9788 333.308C20.7575 330.107 14.3357 331.078 7.64741 334.883C6.68813 335.428 5.90057 336.837 5.05676 337.074C3.1767 337.604 -1.11341 333.805 0.106416 332.097C2.2115 329.145 11.1855 325.367 14.8094 324.876V324.873Z"
                    fill={colors.quinto}
                  />
                  <path
                    d="M15.9821 337.888C19.3603 337.308 26.398 338.063 28.6126 340.97C29.9656 342.746 26.2736 346.341 25.2285 346.545C24.2929 346.726 21.717 344.251 19.3929 344.254C14.9636 344.256 13.6076 349.39 9.58987 343.404C7.72461 340.627 13.7615 338.273 15.9821 337.891V337.888Z"
                    fill={colors.quinto}
                  />
                  <path
                    d="M368.463 219.909V178.162C368.463 162.023 387.989 149.792 403.033 151.291C415.385 152.519 430.639 165.129 430.639 178.162V219.02C430.639 220.335 423.533 220.335 423.533 219.02V177.57C423.533 175.509 419.971 169.016 418.506 167.202C405.319 150.846 379.232 157.878 375.631 178.227L375.486 218.94C374.897 220.743 370.071 219.615 368.463 219.912V219.909Z"
                    fill={colors.quinto}
                  />
                  <path
                    d="M26.2026 204.513C26.7178 205.028 25.1486 210.881 24.4499 211.346C22.5432 212.622 4.25175 211.006 0.524189 211.536C-0.757809 211.103 -1.82071 205.996 -1.62826 204.51H26.2026V204.513Z"
                    fill={colors.quinto}
                  />
                  <path
                    d="M26.7949 139.969H-1.62815C-1.69033 138.542 -0.671841 133.941 0.524296 133.535C7.53828 134.044 16.1718 132.582 22.9785 133.423C26.0902 133.807 25.2968 137.662 26.7949 139.969Z"
                    fill={colors.quinto}
                  />
                  <path
                    d="M15.5439 159.51V172.537H25.0182V179.05H9.03027V159.51H15.5439Z"
                    fill={colors.quinto}
                  />
                  <path
                    d="M382.083 46.4095H373.2L370.835 70.6905L364.031 71.2886L366.687 46.4095H313.986L317.536 80.159L310.43 80.1649L307.475 46.4066C306.03 46.2112 298.59 47.0402 298.59 45.5213V27.1648C298.59 27.1026 299.416 26.2766 299.478 26.2766H381.194C381.257 26.2766 382.083 27.1026 382.083 27.1648V46.4095ZM305.696 33.3823V39.8959H374.977V33.3823H305.696Z"
                    fill={colors.quinto}
                  />
                  <path
                    d="M67.5641 29.8975C67.5641 46.1045 54.4274 59.2413 38.2203 59.2413C22.0132 59.2413 8.87646 46.1045 8.87646 29.8975C8.87646 13.6904 22.0132 0.55365 38.2203 0.55365C54.4274 0.55365 67.5641 13.6904 67.5641 29.8975ZM60.7574 29.9064C60.7574 17.4387 50.6524 7.33373 38.1848 7.33373C25.7171 7.33373 15.6121 17.4387 15.6121 29.9064C15.6121 42.374 25.7171 52.479 38.1848 52.479C50.6524 52.479 60.7574 42.374 60.7574 29.9064Z"
                    fill={colors.quinto}
                  />
                  <path
                    d="M104.958 480.453C104.464 480.021 106.148 478.099 106.513 477.567C110.208 472.11 118.421 460.166 122.735 455.891C123.365 455.266 123.741 454.479 124.81 454.414L238.067 454.529C242.896 462.704 250.763 470.162 255.597 478.147C256.048 478.89 256.743 479.447 256.551 480.45H248.261L234.964 462.067L233.632 461.031L128.366 460.924L126.548 462.067L113.251 480.45H104.961L104.958 480.453Z"
                    fill={colors.quinto}
                  />
                  <path
                    d="M171.281 437.816V444.927H164.17C163.66 437.567 163.93 437.307 171.281 437.816Z"
                    fill={colors.quinto}
                  />
                  <path
                    d="M193.792 437.81H187.258V444.936H193.792V437.81Z"
                    fill={colors.quinto}
                  />
                  <path
                    d="M51.0111 97.9915C51.2687 98.2106 51.9467 103.294 52.3878 104.606C57.8977 120.982 82.3031 121.591 88.4851 105.441C89.0417 103.99 89.921 98.2372 90.2112 97.9885C90.7086 97.5651 95.4635 98.1632 96.6685 97.9263C95.2119 132.514 45.963 132.434 44.5537 97.9263C45.7647 98.1661 50.4989 97.5622 51.0081 97.9915H51.0111Z"
                    fill={colors.quinto}
                  />
                  <path
                    d="M83.6411 78.3854H77.1274V94.9656H83.6411V78.3854Z"
                    fill={colors.quinto}
                  />
                  <path
                    d="M64.1 78.3854H57.5864V94.9656H64.1V78.3854Z"
                    fill={colors.quinto}
                  />
                  <path
                    d="M25.4388 85.0116C25.4388 101.222 12.299 114.361 -3.91099 114.361C-20.121 114.361 -33.2607 101.222 -33.2607 85.0116C-33.2607 68.8015 -20.121 55.6618 -3.91099 55.6618C12.299 55.6618 25.4388 68.8015 25.4388 85.0116ZM18.635 84.982C18.635 72.5113 8.5241 62.4004 -3.94651 62.4004C-16.4171 62.4004 -26.528 72.5113 -26.528 84.982C-26.528 97.4526 -16.4171 107.563 -3.94651 107.563C8.5241 107.563 18.635 97.4526 18.635 84.982Z"
                    fill={colors.quinto}
                  />
                </g>
              </g>
              <defs>
                <clipPath id="clip0_629_286">
                  <rect width={375} height={547} rx={40} fill={colors.quinto} />
                </clipPath>
                <clipPath id="clip1_629_286">
                  <rect
                    width={539.446}
                    height={514.709}
                    fill={colors.quinto}
                    transform="translate(-76.8311 -21.1989)"
                  />
                </clipPath>
              </defs>
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
};
